import { saveAs } from "file-saver";
import * as XLSX from "xlsx";

export function generateCounterpartiesXlsx(
  counterparties: any[],
  name: string,
  t: any,
) {
  const processFiatCounterparties = counterparties
    .map((counterparty) => {
      if (counterparty.rails[0] !== "CRYPTO") {
        return {
          "Counterparty ID": counterparty.id ?? "-",
          "Customer ID": counterparty.customer?.id ?? "-",
          Rail: counterparty.rails[0] ?? "-",
          Type: counterparty.counterpartyType ?? "-",
          "Customer Owner First Name/Registered Name":
            (counterparty.customer?.application?.customerDetailsCorporation
              ?.registeredName ||
              counterparty.customer?.application?.registeredName ||
              counterparty.customer?.application?.customerDetailsIndividual
                ?.firstName ||
              counterparty.customer?.application?.firstName) ??
            "-",
          "Customer Owner Last Name/Trading Name":
            (counterparty.customer?.application?.customerDetailsCorporation
              ?.tradingName ||
              counterparty.customer?.application?.tradingName ||
              counterparty.customer?.application?.customerDetailsIndividual
                ?.lastName ||
              counterparty.customer?.application?.lastName) ??
            "-",
          "Customer Owner Entity Type":
            counterparty.customer?.application?.customerDetailsCorporation
              ?.registeredName ||
            counterparty.customer?.application?.registeredName
              ? "CORPORATION"
              : "INDIVIDUAL",
          "Counterparty Name": counterparty.profile?.name ?? "-",
          "Counterparty Relationship to Customer":
            counterparty.profile?.relationshipToCustomer ?? "-",
          "Counterparty Address":
            counterparty.profile?.address?.addressLine1 ?? "-",
          "Counterparty Country":
            counterparty.profile?.address?.countryCode ?? "-",
          "Counterparty State": counterparty.profile?.address?.state ?? "-",
          "Counterparty City": counterparty.profile?.address?.city ?? "-",
          "Counterparty ZIP Code":
            counterparty.profile?.address?.postalCode ?? "-",
          "Counterparty Bank Name":
            counterparty.accountInformation?.institutionName ?? "-",
          "Counterparty Account Number":
            counterparty.accountInformation?.accountNumber ?? "-",
          "Counterparty Routing Number":
            counterparty.accountInformation?.routingNumber ?? "-",
          "Counterparty IBAN": counterparty.accountInformation?.iban ?? "-",
          "Counterparty Swift BIC":
            counterparty.accountInformation?.swiftBic ?? "-",
          "Counterparty Bank Address":
            counterparty.accountInformation?.institutionAddress?.addressLine1 ??
            "-",
          "Counterparty Bank Country":
            counterparty.accountInformation?.institutionAddress?.countryCode ??
            "-",
          "Counterparty Bank State":
            counterparty.accountInformation?.institutionAddress?.state ?? "-",
          "Counterparty Bank City":
            counterparty.accountInformation?.institutionAddress?.city ?? "-",
          "Counterparty Bank ZIP Code":
            counterparty.accountInformation?.institutionAddress?.postalCode ??
            "-",
        };
      }
      return null;
    })
    .filter((item) => item !== null);

  const processCryptoCounterparties = counterparties
    .map((counterparty) => {
      if (counterparty.rails[0] === "CRYPTO") {
        return {
          "Counterparty ID": counterparty.id ?? "-",
          "Customer ID": counterparty.customer?.id ?? "-",
          Rail: counterparty.rails[0] ?? "-",
          Type: counterparty.counterpartyType ?? "-",
          "Customer Owner First Name/Registered Name":
            (counterparty.customer?.application?.customerDetailsCorporation
              ?.registeredName ||
              counterparty.customer?.application?.registeredName ||
              counterparty.customer?.application?.customerDetailsIndividual
                ?.firstName ||
              counterparty.customer?.application?.firstName) ??
            "-",
          "Customer Owner Last Name/Trading Name":
            (counterparty.customer?.application?.customerDetailsCorporation
              ?.tradingName ||
              counterparty.customer?.application?.tradingName ||
              counterparty.customer?.application?.customerDetailsIndividual
                ?.lastName ||
              counterparty.customer?.application?.lastName) ??
            "-",
          "Customer Owner Entity Type":
            counterparty.customer?.application?.customerDetailsCorporation
              ?.registeredName ||
            counterparty.customer?.application?.registeredName
              ? "CORPORATION"
              : "INDIVIDUAL",
          "Counterparty Name": counterparty.profile?.name ?? "-",
          "Counterparty Relationship to Customer":
            counterparty.profile?.relationshipToCustomer ?? "-",
          "Counterparty Country":
            counterparty.profile?.address?.countryCode ?? "-",
          "Counterparty Wallet Address":
            counterparty.walletInformation?.blockchainAddress ?? "-",
          "Counterparty Wallet Type":
            counterparty.walletInformation?.assetTypeId ?? "-",
          "Counterparty Institution Name":
            counterparty.walletInformation?.institutionName ?? "-",
          "Counterparty Institution Address":
            counterparty.walletInformation?.institutionAddress?.addressLine1 ??
            "-",
          "Counterparty Institution Country":
            counterparty.walletInformation?.institutionAddress?.countryCode ??
            "-",
          "Counterparty Institution State":
            counterparty.walletInformation?.institutionAddress?.state ?? "-",
          "Counterparty Institution City":
            counterparty.walletInformation?.institutionAddress?.city ?? "-",
          "Counterparty Institution ZIP Code":
            counterparty.walletInformation?.institutionAddress?.postalCode ??
            "-",
        };
      }
      return null;
    })
    .filter((item) => item !== null);

  const columnsLabel = {
    "Counterparty ID": t("management/counterparties:fields.id"),
    "Customer ID": t("management/counterparties:fields.customerid"),
    Rail: t("management/counterparties:fields.rail"),
    Type: t("management/counterparties:fields.type"),
    "Customer Owner First Name/Registered Name": t(
      "management/counterparties:fields.customername",
    ),
    "Customer Owner Last Name/Trading Name": t(
      "management/counterparties:fields.customername2",
    ),
    "Customer Owner Type": t(
      "management/counterparties:fields.counterpartytype",
    ),
    "Counterparty Name": t("management/counterparties:fields.counterpartyname"),
    "Counterparty Relationship to Customer": t(
      "management/counterparties:fields.counterpartyrelationship",
    ),
    "Counterparty Address": t(
      "management/counterparties:fields.counterpartyaddress",
    ),
    "Counterparty Country": t(
      "management/counterparties:fields.counterpartycountry",
    ),
    "Counterparty State": t(
      "management/counterparties:fields.counterpartystate",
    ),
    "Counterparty City": t("management/counterparties:fields.counterpartycity"),
    "Counterparty ZIP Code": t(
      "management/counterparties:fields.counterpartyzipcode",
    ),
    "Counterparty Bank Name": t(
      "management/counterparties:fields.counterpartybankname",
    ),
    "Counterparty Account Number": t(
      "management/counterparties:fields.counterpartyaccountnumber",
    ),
    "Counterparty Routing Number": t(
      "management/counterparties:fields.counterpartyroutingnumber",
    ),
    "Counterparty IBAN": t("management/counterparties:fields.counterpartyiban"),
    "Counterparty Swift BIC": t(
      "management/counterparties:fields.counterpartyswift",
    ),
    "Counterparty Wallet Address": t(
      "management/counterparties:fields.counterpartywalletaddress",
    ),
    "Counterparty Wallet Type": t(
      "management/counterparties:fields.counterpartywallettype",
    ),
    "Counterparty Bank Address": t(
      "management/counterparties:fields.counterpartybankaddress",
    ),
    "Counterparty Bank Country": t(
      "management/counterparties:fields.counterpartybankcountry",
    ),
    "Counterparty Bank State": t(
      "management/counterparties:fields.counterpartybankstate",
    ),
    "Counterparty Bank City": t(
      "management/counterparties:fields.counterpartybankcity",
    ),
    "Counterparty Bank ZIP Code": t(
      "management/counterparties:fields.counterpartybankzipcode",
    ),
  };

  const labelsArray = Object.entries(columnsLabel).map(([column, label]) => ({
    Column: column,
    Label: label,
  }));

  const fiatCounterpartiesSheet = XLSX.utils.json_to_sheet(
    processFiatCounterparties,
  );
  const cryptoCounterpartiesSheet = XLSX.utils.json_to_sheet(
    processCryptoCounterparties,
  );
  const labelsSheet = XLSX.utils.json_to_sheet(labelsArray);

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(
    wb,
    fiatCounterpartiesSheet,
    "FIAT Counterparties",
  );
  XLSX.utils.book_append_sheet(
    wb,
    cryptoCounterpartiesSheet,
    "CRYPTO Counterparties",
  );
  XLSX.utils.book_append_sheet(wb, labelsSheet, "Labels");

  const wbBlob = new Blob(
    [XLSX.write(wb, { bookType: "xlsx", type: "array" })],
    {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    },
  );

  const checkName = name ? name : "izziwallet";
  saveAs(wbBlob, `${checkName}_exported_counterparties.xlsx`);
}
